import { useAppSelector } from '~/common/stores';

/**
 * 프로필 상태 구독 훅.
 * @description fetch 는 페이지 useEffect 에서만 하고 여기서는 구독·파생만 한다(hoya-admin 규약).
 *  `needsOnboarding` 을 화면마다 계산하면 "조회 전"과 "미등록"을 헷갈려 온보딩 유도가 깜빡이므로
 *  판정을 여기 한 곳으로 모은다.
 */
function useProfile() {
  const state = useAppSelector(state => state.profile);

  return {
    ...state,
    /**
     * 조회가 끝났고, 그 결과 프로필이 없을 때만 참 — 로딩 중에는 거짓이라 깜빡임이 없다.
     * @description 지도사는 제외한다. 온보딩은 반려견 등록 절차라 지도사에게는 해당이 없는데,
     *  그대로 두면 지도사에게 영영 사라지지 않는 "프로필 등록" 배너가 남는다.
     */
    needsOnboarding: state.isLoaded && state.onboarding === null && state.me?.role !== 'tutor',
    petName: state.onboarding?.pet.name,
    nickname: state.onboarding?.guardian.nickname,
    /** 지도사 계정인지 — 화면 분기용(차단은 RLS 가 한다). */
    isTutor: state.me?.role === 'tutor',
    myProfileId: state.me?.id ?? null,
    petPhotoUrl: state.onboarding?.pet.photoUrl,
    guardianPhotoUrl: state.onboarding?.guardian.photoUrl,
  };
}

export default useProfile;
